<template>
  <div class="article">
    <p class="article-title">
      {{ $t('2022.01-2024.07 三年陪伴的答卷——“把爱传下去”第一期回顾') }}
    </p>
    <p class="article-time">2025/10/21</p>
    <div class="article-body">

      <p class="article-para">
        {{ $t('自2022年正式启动至2024年圆满收官，CBiBank公益项目“把爱传下去”第一期累计捐赠人民币13.8万元，资助10名来自四川和云南的女同学继续完成高中学业。') }}
      </p>
      <template v-if="$store.state.app.lang === 'zh-CN'">
        <p class="article-para">
          与把爱传下去合作的一个村小的老师每个学期都会亲赴孩子们的学校回访，面对面了解孩子们的最新情况，并把她们的心声记录下来带给我们；我们的志愿者们定期与孩子们线上联系，为孩子们加油鼓劲。先后有志愿者12人，真诚并耐心地给予孩子们陪伴、通过线上的一通通电话、一条条信息、输送关爱，支持孩子们走到高三，完成高中学业，追求更广阔的人生。
        </p>
      </template>
      <template v-else>
        <p class="article-para">
          Each semester, teachers from One-School — the partner organization through which Pay It Forward provides support — personally visited the students’ schools. They met the girls face-to-face, learned about their latest circumstances, and recorded their stories to share with us.
        </p>
        <p class="article-para">
          Meanwhile, our volunteers kept in regular contact with the girls online — sending encouragement, sharing warmth, and offering emotional support through calls and messages. Over the years,12     dedicated volunteers have offered heartfelt companionship — through countless phone calls and messages, they’ve shared love and encouragement, helping the girls reach their final year of high school and step into a wider world.
        </p>
      </template>

      <p class="article-para">
        {{ $t('2024年把爱传下去第一期捐助圆满结束，受捐的10名女生都坚持到了高三，其中，9名顺利通过高考进入了更高的学府学习深造，1名找到了满意的工作，开启了新的人生旅程：') }}
      </p>
      <div class="article-img-max-1000">
        <img
          src="@/assets/image/news-detail/20251021/img-1.png"
          alt=""
        />
      </div>
      <p class="article-h3-sub">
        {{ $t('宋依然：从凉山到德阳，一份安静的坚持') }}
      </p>
      <p class="article-para">
        {{ $t('通过把爱传下去助学基金捐助的孩子宋依然已顺利完成高中阶段的学业，其高考成绩理科317分【四川省理科一本线539分，理科二本线459分】，已录取到德阳科贸职业技术学院会计学专业就读。') }}
      </p>
      <p class="article-h3-sub">
        {{ $t('罗欣梅：乘风起航，去看更大的世界') }}
      </p>
      <p class="article-para">
        {{ $t('通过把爱传下去助学基金捐助的孩子罗欣梅已顺利完成高中阶段的学业，其高考成绩理科402分【云南省理科一本线505分，二本线420分】，已录取到云南机电职业技术学院民航运输服务专业就读。') }}
      </p>
      <p class="article-h3-sub">
        {{ $t('李婉珍：用双手去治愈，也去改变') }}
      </p>
      <p class="article-para">
        {{ $t('通过把爱传下去助学基金捐助的孩子李婉珍已顺利完成高中阶段的学业，其今年的高考成绩文科392分【云南省文科一本线550分，二本线480分】，已录取到云南现代职业技术学院康复治疗专业就读。') }}
      </p>
      <p class="article-h3-sub">
        {{ $t('赵语青：电子商务，新的起点') }}
      </p>
      <p class="article-para">
        {{ $t('通过把爱传下去助学基金捐助的孩子赵语青已顺利完成高中阶段的学业，学生参加了普通高等职业院校单独考试招生（单招考试），已录取到云南旅游职业学院电子商务专业就读。') }}
      </p>
      <p class="article-h3-sub">
        {{ $t('彭晓露：用努力照亮前路') }}
      </p>
      <p class="article-para">
        {{ $t('通过把爱传下去助学基金捐助的孩子彭晓露已顺利完成高中阶段的学业，其高考成绩理科580分【云南省理科一本线505分，二本线420分】，录取到了云南大学的信息与计算科学专业就读。') }}
      </p>
      <p class="article-h3-sub">
        {{ $t('唐思婕：选择护理，选择温柔的力量') }}
      </p>
      <p class="article-para">
        {{ $t('通过把爱传下去助学基金捐助的孩子唐思婕已顺利完成高中阶段的学业，录取到四川国际标榜职业学院，学习护理专业。') }}
      </p>
      <p class="article-h3-sub">
        {{ $t('金阿卓：守护童年，守护笑容') }}
      </p>
      <p class="article-para">
        {{ $t('通过把爱传下去助学基金捐助的孩子金阿卓已顺利完成高中阶段的学业，录取到了四川托普信息技术职业学院，学前教育专业。') }}
      </p>
      <p class="article-h3-sub">
        {{ $t('顾清雅：用科学守护健康') }}
      </p>
      <p class="article-para">
        {{ $t('通过把爱传下去助学基金捐助的孩子顾清雅已顺利完成高中阶段的学业，高考成绩理科540分【四川省理科一本线539分，理科二本线459分】，已录取到西南医科大学的食品卫生与安全专业。') }}
      </p>
      <p class="article-h3-sub">
        {{ $t('阿宁莎：慢一点，但不放弃') }}
      </p>
      <p class="article-para">
        {{ $t('通过把爱传下去助学基金捐助的孩子阿宁莎已顺利完成高中阶段的学业，其高考成绩文科379分【四川省文科一本线529分，二本线457分】，升学到了南充职业技术学院早期教育专业就读。') }}
      </p>
      <p class="article-h3-sub">
        {{ $t('何笑岚：生活的答案不止一种') }}
      </p>
      <p class="article-para">
        {{ $t('通过把爱传下去助学基金捐助的孩子何笑岚同学坚持读到高三，目前在昆明的一家餐饮店做服务员的工作，店里包吃住，她对目前的生活状态很满意，表示会继续干下去。虽然未能继续深造学习略有遗憾，但人生本就没有统一的标准答案，在艰苦的环境中坚持学习和生活已经十分不易，祝福她。') }}
      </p>
      <p class="article-para">
        {{ $t('*注：为保护孩子隐私，以上信息均使用化名') }}
      </p>
      <p class="article-h2">
        {{ $t('· 总结') }}
      </p>
      <p class="article-para">
        {{ $t('至此，“把爱传下去”第一期捐助项目圆满结束。十位女孩无论是继续深造，还是踏入社会，都完成了人生中最艰难的一段旅程，逐渐成长为更有力量的自己，能够更加自主地把握未来。2025年8月，我们又携手10位新的同学踏上新的征程，期待与她们共同续写温暖的故事。') }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  methods: {
  }
}
</script>

<style scoped lang="less">
</style>
